import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Clear the hash from URL history
        window.history.replaceState(null, "", window.location.pathname);
        if (data?.user) setUser(data.user);
        toast.success(`Selamat datang, ${data?.user?.name || "pengguna"}`);
        navigate("/", { replace: true, state: { user: data?.user } });
      } catch (err) {
        const d = err?.response?.data?.detail || "Login Google gagal";
        toast.error(typeof d === "string" ? d : "Login Google gagal");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-slate-50">
      <Loader2 className="w-8 h-8 animate-spin text-slate-500" />
      <div className="text-sm text-slate-600">Memproses login Google...</div>
    </div>
  );
}
